/* MOMMYSLOVE — Guia de tallas + calculadora por medidas reales de cada prenda.
   La config del producto llega en window.MMLSizeCfg (la pinta la seccion mml-size-chart-js).
   Las medidas las lee del propio desplegable (data-mml-sizes), asi que solo viven en un sitio. */
(function () {
  var C = (window.MMLSizeCfg || {});
  var CFG = {
    anchorChest: C.anchorChest || 101,
    anchorWaist: C.anchorWaist || 87,
    useLength:   C.useLength !== false,
    topLen:      C.topLen  || 0.37,
    pantLen:     C.pantLen || 0.59,
    lenTol:      C.lenTol  || 4
  };
  var DEFAULT_SIZE = C.defaultSize || '';
  var RAW_SIZES    = C.allSizes    || '';
  var STOCK_SIZES  = C.stockSizes  || '';

  /* ---------- Acordeon Guia de Tallas ---------- */
  function initChart() {
    document.querySelectorAll('.MMLSizeChart__Toggle').forEach(function (btn) {
      if (btn.dataset.mmlBound === '1') return;
      btn.dataset.mmlBound = '1';
      btn.addEventListener('click', function () {
        var panel = btn.parentNode.querySelector('.MMLSizeChart__Content');
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
      });
    });
  }

  /* ---------- Talla M por defecto ---------- */
  function initDefaultSize() {
    if (!DEFAULT_SIZE) return;
    if (window.location.search.indexOf('variant=') !== -1) return;
    if (window.__mmlDefaultSizeDone) return;
    var radios = document.querySelectorAll('input.SizeSwatch__Radio');
    if (!radios.length) return;
    var target = null;
    radios.forEach(function (r) {
      if (!target && r.value && r.value.trim().toUpperCase() === DEFAULT_SIZE) target = r;
    });
    if (!target) return;
    window.__mmlDefaultSizeDone = true;
    if (target.checked) return;
    var label = document.querySelector('label[for="' + target.id + '"]');
    if (label) { label.click(); } else { target.click(); }
  }

  /* =========================================================
     CALCULADORA CON LAS MEDIDAS REALES DE CADA PRENDA

     1. Lee la tabla de medidas de esta prenda (data-mml-sizes).
     2. Pasa el ancho en plano a contorno (x2).
     3. Monta la escala de cuerpo de ESTA prenda anclando su M al
        cuerpo de referencia (anchorChest / anchorWaist). Asi cada
        prenda recomienda segun su propio corte: una hoodie con 132 cm
        de pecho en M no pide el mismo cuerpo que una camiseta con 123.
     4. Ajusta por el fit elegido (-1 / 0 / +1 talla).
     5. Comprueba el largo contra la altura y sube si se queda corta.
     ========================================================= */

  function num(x) {
    if (x === null || x === undefined || x === '') return null;
    var v = parseFloat(String(x).replace(',', '.'));
    return isNaN(v) ? null : v;
  }

  function listSizes(str) {
    var out = [];
    if (!str) return out;
    String(str).split(',').forEach(function (s) {
      var v = s.trim().toUpperCase();
      if (v && out.indexOf(v) === -1) out.push(v);
    });
    return out;
  }

  var ALL_SIZES = listSizes(RAW_SIZES);
  var IN_STOCK = listSizes(STOCK_SIZES);

  function chartData() {
    var el = document.querySelector('.MMLSizeChart[data-mml-sizes]');
    if (!el) return null;
    try {
      var d = JSON.parse(el.getAttribute('data-mml-sizes'));
      if (!d || !d.cm || !d.names || !d.sizes) return null;
      d.cmNum = d.cm.map(function (r) { return r.map(num); });
      return d;
    } catch (e) { return null; }
  }

  function rowByName(d, name) {
    var i = d.names.indexOf(name);
    return i < 0 ? null : d.cmNum[i];
  }

  function allowedIdx(d) {
    var pool = IN_STOCK.length ? IN_STOCK : ALL_SIZES;
    var out = [];
    d.sizes.forEach(function (s, i) {
      if (pool.indexOf(String(s).toUpperCase()) !== -1) out.push(i);
    });
    if (!out.length) d.sizes.forEach(function (s, i) { out.push(i); });
    return out;
  }

  function nearestAllowed(i, idxs) {
    if (idxs.indexOf(i) !== -1) return i;
    var best = idxs[0], bd = Infinity;
    idxs.forEach(function (j) {
      var dd = Math.abs(j - i);
      if (dd < bd) { bd = dd; best = j; }
    });
    return best;
  }

  function bodyLadder(contornos, anchor, sizes) {
    var mi = sizes.indexOf('M');
    if (mi < 0) mi = Math.floor(sizes.length / 2);
    return contornos.map(function (v) { return anchor + (v - contornos[mi]); });
  }

  function estChest(h, w) { return Math.round(0.48 * w + 0.35 * h); }
  function estWaist(h, w) { return Math.round(0.55 * w + 0.24 * h); }

  function fmt(n) {
    if (n === null || n === undefined) return '';
    return (Math.round(n * 10) / 10).toString().replace('.', ',');
  }

  function applyFit(i, fit, n) {
    if (fit === 'SLIM') i = i - 1;
    if (fit === 'OVER') i = i + 1;
    return Math.max(0, Math.min(n - 1, i));
  }

  function lengthBump(pick, largo, height, factor, idxs) {
    if (!CFG.useLength || !largo || !height) return { i: pick, bumped: false };
    var target = height * factor;
    if (largo[pick] >= target - CFG.lenTol) return { i: pick, bumped: false };
    for (var k = 0; k < idxs.length; k++) {
      var j = idxs[k];
      if (j > pick && largo[j] >= target - CFG.lenTol) return { i: j, bumped: true };
    }
    return { i: pick, bumped: false };
  }

  function recommendTop(d, chest, height, fit) {
    var flat = rowByName(d, 'Ancho pecho');
    var largo = rowByName(d, 'Largo prenda');
    if (!flat) return null;

    var cont = flat.map(function (v) { return v * 2; });
    var body = bodyLadder(cont, CFG.anchorChest, d.sizes);
    var idxs = allowedIdx(d);

    var pick = -1, maxed = false;
    for (var k = 0; k < body.length; k++) {
      if (body[k] >= chest) { pick = k; break; }
    }
    if (pick < 0) { pick = body.length - 1; maxed = true; }

    pick = applyFit(pick, fit, d.sizes.length);
    var lb = lengthBump(pick, largo, height, CFG.topLen, idxs);
    pick = nearestAllowed(lb.i, idxs);

    return {
      i: pick,
      maxed: maxed,
      bumped: lb.bumped,
      contorno: cont[pick],
      flat: flat[pick],
      largo: largo ? largo[pick] : null,
      ease: cont[pick] - chest
    };
  }

  function recommendPant(d, waist, height, fit) {
    var flat = rowByName(d, 'Ancho cintura');
    var largo = rowByName(d, 'Largo total');
    if (!flat) return null;

    var cont = flat.map(function (v) { return v * 2; });
    var body = bodyLadder(cont, CFG.anchorWaist, d.sizes);
    var idxs = allowedIdx(d);

    var pick = -1, maxed = false;
    for (var k = 0; k < body.length; k++) {
      if (body[k] >= waist) { pick = k; break; }
    }
    if (pick < 0) { pick = body.length - 1; maxed = true; }

    pick = applyFit(pick, fit, d.sizes.length);
    var lb = lengthBump(pick, largo, height, CFG.pantLen, idxs);
    pick = nearestAllowed(lb.i, idxs);

    return {
      i: pick,
      maxed: maxed,
      bumped: lb.bumped,
      contorno: cont[pick],
      flat: flat[pick],
      largo: largo ? largo[pick] : null
    };
  }

  function formHtml(d, sid) {
    var isPant = d.type === 'pant';
    var mLabel = isPant ? 'Contorno de cintura (cm)' : 'Contorno de pecho (cm)';
    var mHint = isPant
      ? 'Por encima del hueso de la cadera, sin apretar.'
      : 'Por la parte más ancha del pecho, con los brazos abajo.';
    var mPh = isPant ? 'Ej: 84' : 'Ej: 100';

    var fits = isPant
      ? [['SLIM', 'Ajustado'], ['REG', 'Como está diseñado'], ['OVER', 'Aún más holgado']]
      : [['SLIM', 'Ajustado'], ['REG', 'Como está diseñado'], ['OVER', 'Aún más oversized']];

    var opts = '<option value="">Selecciona</option>';
    fits.forEach(function (f) {
      opts += '<option value="' + f[0] + '"' + (f[0] === 'REG' ? ' selected' : '') + '>' + f[1] + '</option>';
    });

    return '' +
      '<p class="SizeCalc-intro">Te calculo la talla con las medidas reales de esta prenda.</p>' +
      '<div class="SizeCalc-row">' +
        '<label class="SizeCalc-label" for="MMLCalcH-' + sid + '">Altura (cm)</label>' +
        '<input type="number" inputmode="numeric" class="SizeCalc-input" id="MMLCalcH-' + sid + '" min="140" max="220" placeholder="Ej: 178">' +
      '</div>' +
      '<div class="SizeCalc-row">' +
        '<label class="SizeCalc-label" for="MMLCalcW-' + sid + '">Peso (kg)</label>' +
        '<input type="number" inputmode="numeric" class="SizeCalc-input" id="MMLCalcW-' + sid + '" min="35" max="180" placeholder="Ej: 75">' +
      '</div>' +
      '<div class="SizeCalc-row">' +
        '<label class="SizeCalc-label" for="MMLCalcM-' + sid + '">' + mLabel +
          ' <span class="SizeCalc-opt">opcional, más preciso</span></label>' +
        '<input type="number" inputmode="numeric" class="SizeCalc-input" id="MMLCalcM-' + sid + '" min="50" max="180" placeholder="' + mPh + '">' +
        '<span class="SizeCalc-hint">' + mHint + '</span>' +
      '</div>' +
      '<div class="SizeCalc-row">' +
        '<label class="SizeCalc-label" for="MMLCalcF-' + sid + '">Cómo te gusta que quede</label>' +
        '<select class="SizeCalc-select" id="MMLCalcF-' + sid + '">' + opts + '</select>' +
      '</div>' +
      '<button type="button" class="SizeCalc-submit" id="MMLCalcGo-' + sid + '">Calcular mi talla</button>';
  }

  function resultHtml(d, res, ctx) {
    var size = d.sizes[res.i];
    var lines = [];

    if (d.type === 'pant') {
      lines.push('Cintura de la prenda <b>' + fmt(res.contorno) + ' cm</b> en relajado (' + fmt(res.flat) +
        ' cm en plano × 2). Lleva goma y cordón, así que se ajusta sobre tus ' + fmt(ctx.measure) + ' cm.');
      if (res.largo) lines.push('Largo total <b>' + fmt(res.largo) + ' cm</b> para tus ' + fmt(ctx.height) + ' cm.');
      if (res.bumped) lines.push('He subido una talla por tu altura: la anterior se te quedaba corta de pierna.');
    } else {
      lines.push('Pecho de la prenda <b>' + fmt(res.contorno) + ' cm</b> (' + fmt(res.flat) +
        ' cm en plano × 2). Sobre tus ' + fmt(ctx.measure) + ' cm te deja <b>' + fmt(res.ease) + ' cm</b> de holgura.');
      if (res.largo) lines.push('Largo de la prenda <b>' + fmt(res.largo) + ' cm</b>.');
      if (res.bumped) lines.push('He subido una talla por tu altura, para que no se te quede corta.');
    }

    if (res.maxed) {
      lines.push('Es la talla más grande que hay: te quedará algo menos holgada de lo que buscas.');
    }
    if (ctx.estimated) {
      lines.push('<em>Esa medida la he estimado con tu altura y peso. Si te mides con una cinta y la pones, afino más.</em>');
    }

    return '' +
      '<div class="SizeCalc-result">' +
        '<p class="SizeCalc-result-label">Tu talla recomendada</p>' +
        '<div class="SizeCalc-result-size">' + size + '</div>' +
        '<p class="SizeCalc-result-analysis">' + lines.join('<br><br>') + '</p>' +
      '</div>' +
      '<button type="button" class="SizeCalc-submit SizeCalc-closeResult">Entendido</button>' +
      '<button type="button" class="SizeCalc-again">Calcular otra vez</button>';
  }

  function initCalc() {
    var d = chartData();
    if (!d) return; /* gorras y demas: se queda la calculadora original */

    document.querySelectorAll('[id^="SizeCalcBody-"]').forEach(function (body) {
      if (body.dataset.mmlCalc === '1') return;
      body.dataset.mmlCalc = '1';

      var sid = body.id.replace('SizeCalcBody-', '');
      var overlay = document.getElementById('SizeCalcOverlay-' + sid);
      var popup = document.getElementById('SizeCalcPopup-' + sid);

      function closePopup() {
        if (overlay) overlay.classList.remove('active');
        if (popup) popup.classList.remove('active');
        document.body.style.overflow = '';
      }

      function showForm() {
        body.innerHTML = formHtml(d, sid);
        var go = document.getElementById('MMLCalcGo-' + sid);
        if (go) go.addEventListener('click', calculate);
      }

      function calculate() {
        var hEl = document.getElementById('MMLCalcH-' + sid);
        var wEl = document.getElementById('MMLCalcW-' + sid);
        var mEl = document.getElementById('MMLCalcM-' + sid);
        var fEl = document.getElementById('MMLCalcF-' + sid);
        if (!hEl || !wEl || !fEl) return;

        var old = body.querySelector('.SizeCalc-error');
        if (old) old.remove();

        var h = num(hEl.value);
        var w = num(wEl.value);
        var m = num(mEl ? mEl.value : null);
        var fit = fEl.value;

        if (!h || !w || !fit) {
          var err = document.createElement('p');
          err.className = 'SizeCalc-error';
          err.textContent = 'Necesito tu altura, tu peso y cómo te gusta que quede.';
          var go = document.getElementById('MMLCalcGo-' + sid);
          if (go && go.parentNode) go.parentNode.insertBefore(err, go.nextSibling);
          return;
        }

        var isPant = d.type === 'pant';
        var estimated = false;
        if (!m) {
          m = isPant ? estWaist(h, w) : estChest(h, w);
          estimated = true;
        }

        var res = isPant ? recommendPant(d, m, h, fit) : recommendTop(d, m, h, fit);
        if (!res) return;

        body.innerHTML = resultHtml(d, res, { measure: m, height: h, estimated: estimated });

        var close = body.querySelector('.SizeCalc-closeResult');
        if (close) close.addEventListener('click', closePopup);
        var again = body.querySelector('.SizeCalc-again');
        if (again) again.addEventListener('click', showForm);
      }

      showForm();
    });
  }

  function init() { initChart(); initCalc(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    setTimeout(initDefaultSize, 150);
  });

  document.addEventListener('shopify:section:load', init);
})();
